import type { AuthTranslations } from "../../types/auth";

export const auth: AuthTranslations = {
  emailVerificationRequired: "Teie e-posti aadress tuleb enne sisselogimist kinnitada.",
  verificationEmailSent: "Kinnitusmeili saadetud",
  verificationEmailSentDesc: "Palun kontrollige oma postkasti ja klikkige kinnituslingil.",
  loadingInvitation: "Kutse andmete laadimine...",
  signingUpToJoin: "Registreerud liitumiseks",
  asRole: "rollis",
  emailFromInvitation: "E-posti aadress on m\u00E4\u00E4ratud kutsest",
  signupFailed: "Registreerumine eba\u00F5nnestus",
  accountCreatedSuccessfully: "Teie konto on edukalt loodud.",
  goToLogin: "Mine sisselogimisele",
  signUp: "Registreeru",
  noInvitationToken: "Kutse tunnust ei leitud",
  invalidOrExpiredInvitation: "Vigane v\u00F5i aegunud kutse link",
  invitationExpired: "See kutse on aegunud. Palun k\u00FCsige uut kutset.",
  invitationAlreadyAccepted: "See kutse on juba vastu v\u00F5etud.",
  invitationNoLongerValid: "See kutse ei kehti enam.",
  failedToLoadInvitation: "Kutse andmete laadimine eba\u00F5nnestus. Palun proovige uuesti.",
  invitationError: "Kutse viga",
  unableToProcessInvitation: "Kutset ei \u00F5nnestunud t\u00F6\u00F6delda",
  invitationErrorDescription: "Kutse link v\u00F5ib olla poolik, aegunud v\u00F5i juba kasutatud.",
  invitationRetryDescription:
    "Miski katkestas kutse t\u00F6\u00F6tlemise. Kutse v\u00F5ib endiselt kehtida.",
  invitationAccountMismatchDescription:
    "See kutse kuulub teisele e-posti aadressile kui praegu sisselogitud konto.",
  invitationErrorGuidanceTitle: "Kas vajate uut kutset?",
  invitationErrorGuidance:
    "Paluge kutsujal saata uus link. Kui see probleemi ei lahenda, saab Franklini kasutajatugi aidata.",
  invitationRetryGuidanceTitle: "Proovige kutset uuesti",
  invitationRetryGuidance:
    "Proovige kutset kohe uuesti. Kui probleem p\u00FCsib, v\u00F5tke abi saamiseks \u00FChendust Franklini kasutajatoega.",
  invitationAccountMismatchGuidanceTitle: "Kasutage kutsutud kontot",
  invitationAccountMismatchGuidance:
    "Minge sisselogimisele ja kasutage eespool n\u00E4idatud e-posti aadressi v\u00F5i paluge saatjal kutsuda hoopis see konto.",
  contactSupport: "V\u00F5ta \u00FChendust kasutajatoega",
  goToDashboard: "Mine t\u00F6\u00F6lauale",
  welcomeAboard: "Tere tulemast!",
  successfullyJoinedOrg:
    "Olete edukalt liitunud organisatsiooniga {organizationName}. Suuname teid t\u00F6\u00F6lauale...",
  youreInvited: "Teid on kutsutud!",
  createAccountToJoin: "Looge konto, et liituda organisatsiooniga {organizationName}",
  signUpWithEmailAddress: "Palun registreeruge e-posti aadressiga:",
  createAccount: "Loo konto",
  alreadyHaveAccountLogin: "Konto juba olemas? Logi sisse",
  invitationHeading: "Teid on kutsutud organisatsiooniga {organizationName} liituma",
  invitationSubtitle: "Liituge oma meeskonnaga Franklinis.",
  invitationEmailLabel: "E-post",
  invitationEmailHint: "Registreeruge selle aadressiga",
  invitationRoleLabel: "Roll",
  invitationAlreadyHasAccount: "Konto on juba olemas?",
  invitationLogin: "Logi sisse",
  invitationExpiresInOneDay: "See kutse aegub 1 päeva pärast, {date}",
  invitationExpiresInDays: "See kutse aegub {count} päeva pärast, {date}",
  invitationExpiresUnderOneDay: "See kutse aegub vähem kui 24 tunni pärast, {date}",
  invitationExpiredOn: "See kutse aegus {date}",
  invitationExpiryUnavailable: "Kutse aegumiskuupäev pole saadaval",
  acceptInvitation: "V\u00F5ta kutse vastu",
  invitedToJoinOrg: "Teid on kutsutud liituma organisatsiooniga",
  accepting: "Vastuv\u00F5tmine...",
  failedToSignOut: "V\u00E4ljalogimine eba\u00F5nnestus",
  joinedOrgAsRole: "Olete liitunud organisatsiooniga {organizationName} rollis {role}",
  welcomeLetsGetStarted: "Tere tulemast! Alustame!",
  createOrgToManageBuildings: "Looge oma organisatsioon hoonete haldamise alustamiseks",
  joinExistingOrganization: "Liitu olemasoleva organisatsiooniga",
  loadingInvitations: "Kutsete laadimine...",
  pendingInvitations: "Teil on {count} ootel kutset",
  noPendingInvitations: "Ootel kutseid pole",
  noPendingInvites:
    "Ootel kutseid pole. Kui peaks olema, küsi oma organisatsiooni administraatorilt kutset.",
  accept: "N\u00F5ustu",
  signOut: "Logi v\u00E4lja",
  organizationSelected: "Organisatsioon valitud",
  switchedToOrganization: "Olete vahetanud organisatsioonile {organizationName}.",
  userNotFound: "Kasutajat ei leitud. Palun logige uuesti sisse.",
  organizationCreated: 'Organisatsioon "{orgName}" edukalt loodud.',
  createNewOrganization: "Loo uus organisatsioon",
  createOrgDescription: "Sisestage uue organisatsiooni nimi. Seda nime saab hiljem muuta.",
  checkYourEmail: "Kontrollige oma e-posti",
  checkEmailToActivate: "Palun kontrollige oma e-posti konto aktiveerimiseks",
  sentVerificationLinkTo: "Oleme saatnud kinnituslingi aadressile",
  clickLinkToActivate:
    "Kl\u00F5psake e-kirjas olevat linki, et aktiveerida oma konto ja alustada platvormi kasutamist.",
  resendIn: "Saada uuesti {countdown}s p\u00E4rast",
  resendVerificationEmail: "Saada kinnitusmeil uuesti",
  backToLogin: "Tagasi sisselogimisele",
  verificationEmailSentToast: "Kinnitusmeil saadetud! Palun kontrollige oma postkasti.",
  failedToResendEmail: "Kinnitusmeili uuesti saatmine eba\u00F5nnestus",
  authenticationError: "Autentimise viga",
  permissionLoadFailed: "Juurdepääsu kontrollimine ebaõnnestus. Palun proovi uuesti.",
  checkingAccess: "Kontrollin juurdepääsu",
  authSystemError: "Autentimiss\u00FCsteemis tekkis probleem. Palun proovige uuesti sisse logida.",
  adminPrivilegesRequired: "Juurdep\u00E4\u00E4s keelatud: vajalikud administraatori \u00F5igused",
  authenticationRequired: "Autentimine n\u00F5utav",
  insufficientPrivileges: "Juurdep\u00E4\u00E4s keelatud: ebapiisavad \u00F5igused",
  featureComingSoon: "{featureName} on hetkel arenduses ja saab peagi k\u00E4ttesaadavaks.",
  stayTuned:
    "T\u00F6\u00F6tame selle funktsiooni teile pakkumise nimel. J\u00E4\u00E4ge ootama uuendusi!",
  emailMismatchError:
    "See kutse saadeti aadressile {inviteEmail}. Olete praegu sisse logitud kui {currentEmail}. Palun logige v\u00E4lja ja logige sisse \u00F5ige kontoga v\u00F5i registreeruge kutsutud e-postiga.",
  expires: "Aegub {date}",
  welcome: "Tere tulemast!",
  accountCreatedDesc: "Teie konto on edukalt loodud.",
  failedToCreateProfile: "Kasutajaprofiili loomine eba\u00F5nnestus. Palun proovige uuesti.",
  failedToAcceptInvitation: "Kutse vastuv\u00F5tmine eba\u00F5nnestus",
  failedToCreateOrganization: "Organisatsiooni loomine eba\u00F5nnestus",
  failedToAssignOwnerRole: "Omanikurolli m\u00E4\u00E4ramine eba\u00F5nnestus",
  tosTitle: "Kasutustingimused ja privaatsuspoliitika",
  tosBody:
    "Palun tutvuge meie kasutustingimuste ja privaatsuspoliitikaga ning n\u00F5ustuge nendega, et j\u00E4tkata.",
  tosAccept: "N\u00F5ustun",
  tosCheckbox: "Olen lugenud {terms} ja {privacy} ning n\u00F5ustun nendega",
  tosTermsLink: "kasutustingimused",
  tosPrivacyLink: "privaatsuspoliitika",
  tosAccepting: "N\u00F5ustumine...",
  tosFailedToAccept: "Teenusetingimustega n\u00F5ustumine eba\u00F5nnestus. Palun proovige uuesti.",
  tosSignOut: "Logi v\u00E4lja",
  tosProfileUnavailableTitle: "Teie konto laadimine eba\u00F5nnestus",
  tosProfileUnavailableBody:
    "Teie profiili ei \u00F5nnestunud laadida, seet\u00F5ttu ei saa me kinnitada, et olete kasutustingimustega n\u00F5ustunud. Proovige uuesti v\u00F5i logige v\u00E4lja ja uuesti sisse.",
  tosProfileMissingTitle: "Teie konto pole l\u00F5puni seadistatud",
  tosProfileMissingBody:
    "Sisselogimine \u00F5nnestus, kuid teie kontol puudub profiil, seet\u00F5ttu ei saa me kinnitada, et olete kasutustingimustega n\u00F5ustunud. Palun v\u00F5tke \u00FChendust klienditoega.",
  continueWithGoogle: "J\u00E4tka Google'iga",
  orContinueWith: "v\u00F5i",
  signingIn: "Sisselogimine...",
  signingInDesc: "L\u00F5petame Google'iga sisselogimise.",
  googleSignInFailed: "Sisselogimine eba\u00F5nnestus",
  googleSignInFailedDesc:
    "Google'iga sisselogimist ei \u00F5nnestunud l\u00F5petada. Palun proovige uuesti.",
};
